import { uploadSvc } from './uploadSvc';

export default uploadSvc;
